<template>
    <div class="container">
        <!-- No back chevron and no cancel in mandatory mode: the day-change
             question has to be answered, and picking is the only way out. -->
        <span v-if="!mandatory" @click="$emit('close')" role="button"><small><i
                    class="fa-solid fa-chevron-left me-2"></i>{{ $t('common.back') }}</small></span>
        <h2 class="my-3">{{ mandatory ? $t('workTime.stillTitle') : $t('workTime.pickTitle') }}</h2>

        <div class="card shadow border-0">
            <ul class="list-group list-group-flush">
                <li v-for="article in articles" :key="article.id" class="list-group-item p-0">
                    <button type="button" class="btn btn-link text-start text-decoration-none text-body w-100 p-3"
                        :class="{ 'fw-bold': article.id === currentId }" :disabled="saving"
                        @click="$emit('pick', article.id)">
                        <i v-if="article.id === currentId" class="fa-solid fa-check text-success me-2"></i>
                        {{ article.name }}
                    </button>
                </li>
            </ul>
        </div>

        <div v-if="!mandatory" class="row mt-3">
            <div class="col">
                <button @click="$emit('close')" :disabled="saving"
                    class="btn btn-outline-primary w-100">{{ $t('common.cancel') }}</button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'PickWorkTimeModal',
    props: {
        // The selectable work-time articles, in the order the API returned them.
        articles: {
            type: Array,
            required: true
        },
        currentId: {
            type: Number,
            default: null
        },
        // Set when this is the day-change question rather than a voluntary pick.
        mandatory: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close', 'pick']
};
</script>
